























import {Component, Prop, Vue} from 'vue-property-decorator'
import CategoryItemsStore from "@/_common/api/store/modules/CategoryItemsStore";
import DeliousItemsStore from "@/_common/api/store/modules/DeliousItemsStore";
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import DialogWrapper from "@/components/Dialog/parts/DialogWrapper.vue";
import DialogTitle from "@/components/Dialog/parts/DialogTitle.vue";
import DialogOverlay from "@/components/Dialog/parts/DialogOverlay.vue";
import CategoriesStore from "@/_common/api/store/modules/CategoriesStore";


@Component({
    components: {
        DialogWrapper,
        DialogTitle,
        DialogButtons,
        DialogOverlay,
    },
})
export default class DeleteCategoryItemDialog extends Vue {
    @Prop() private categoryItemId!: number;

    get title(): string {
        const categoryItem = CategoryItemsStore.categoryItemById[this.categoryItemId];

        // カテゴリー名取得
        const category = CategoriesStore.categoryById[categoryItem.category_id] || {};
        const categoryName = category.names["jp"] || "このカテゴリー";

        // 商品名取得
        const item = DeliousItemsStore.itemById[categoryItem.item_id] || {};
        const itemName = item.item_name || "商品";

        return "【 " + categoryName + " 】 から 【 " + itemName + " 】 を削除してもよろしいですか？"
    }
}
